
import Cpts020 from '@/components/lyx-components/cpts020/index.vue'
import Toast from 'vux/src/components/toast/index.vue'

import bus from '@/javascript/bus'

export default {
components: {
Cpts020,
Toast
},
data() {
return {
minHeight: '',
sitesNumber: '',
params: JSON.parse(sessionStorage.getItem('historyData')),
scenicSpots: JSON.parse(sessionStorage.getItem('historyData')).scenicSpots ? JSON.parse(sessionStorage.getItem('historyData')).scenicSpots : [],
days: '',
types: JSON.parse(sessionStorage.getItem('historyData')).tags,
visitor: JSON.parse(sessionStorage.getItem('historyData')).visitorType,
status: JSON.parse(sessionStorage.getItem('historyData')).transportType,
stateCode:'632521',
historyData: '',
scenicIds: '',
prompt: false,
spotEmpty: '景点不能为空',
promptNum: false,
spotNum: '您最多只能选择50个景点',
changeData: true,
scienceLever: [{
code: 102001,
name: '非A级'
}, {
code: 102002,
name: 'A'
}, {
code: 102003,
name: 'AA'
}, {
code: 102004,
name: 'AAA'
}, {
code: 102005,
name: 'AAAA'
}, {
code: 102006,
name: 'AAAAA'
}]
};
},
mounted() {
this.minHeight = document.documentElement.clientHeight;

document.title = '行程景点'

if(JSON.stringify(this.params) !== '{}' && this.params.transportType == 1){
this.days = 5
}else{
this.days = JSON.parse(sessionStorage.getItem('historyData')).planDays
}

if(this.params.changeVisitorType || this.params.changeTags || this.params.changeDays || this.params.changeTransportType){
this.changeData = false
}
this.customList()

},
methods: {
customList(){
if(JSON.stringify(this.params) !== '{}' && this.params.scenicSpots && this.params.travelId == undefined && this.changeData){
const scenics = JSON.parse(sessionStorage.getItem('historyData')).scenicSpots
this.scenicSpots = scenics.map(scenic => {
this.scienceLever.map(item => {
if (scenic.level == item.code) {
scenic.level = item.name
}
})
return scenic
})
this.sitesNumber= this.scenicSpots.length
}else if(this.params.changeVisitorType || this.params.changeTags || this.params.changeDays || this.params.changeTransportType){
this.$http.get('api/wtcp-recommend/public/scenicSpot/selectByPreferToChoose?daysTrip=' + this.days + '&tripMode=' + this.status + '&travelTypeIds=' + this.types + '&issue=9&visitorType=' + this.visitor + '&stateCode=' + this.stateCode).then((response) => {
const scenics = response.data.data
this.scenicSpots = scenics.map(scenic => {
this.scienceLever.map(item => {
if (scenic.level == item.code) {
scenic.level = item.name
}
})
return scenic
})
this.sitesNumber= this.scenicSpots.length
})
}else if(!this.params.changeVisitorType && !this.params.changeTags && !this.params.changeDays && this.params.travelId && !this.params.changeTransportType){
const scenics = JSON.parse(sessionStorage.getItem('historyData')).scenicSpots
this.scenicSpots = scenics.map(scenic => {
this.scienceLever.map(item => {
if (scenic.level == item.code) {
scenic.level = item.name
}
})
return scenic
})
this.sitesNumber= this.scenicSpots.length
}
},
cancelSpot(item,index){
this.scenicSpots.splice(index,1)
this.sitesNumber= this.scenicSpots.length
},
addSpot(){
this.scenicIds = this.scenicSpots.map(item => {
return item.id
})
this.params['scenicIds'] = this.scenicIds
this.params['scenicSpots'] = this.scenicSpots
this.params['changeVisitorType'] = false
this.params['changeTags'] = false
this.params['changeDays'] = false
this.params['changeTransportType'] = false
sessionStorage.setItem('historyData', JSON.stringify(this.params))

this.$router.push({path: '/choose-scenic'})
},
generateTtrip(){
if( this.scenicSpots.length == 0 ){

this.prompt = true

}else if(this.sitesNumber > 50){

this.promptNum = true

}
else{
this.scenicIds = this.scenicSpots.map(item => {
return item.id
})
this.params['scenicIds'] = this.scenicIds
this.params['scenicSpots'] = this.scenicSpots
this.params['planDays'] = this.days

sessionStorage.setItem('historyData', JSON.stringify(this.params))

this.$router.replace({path: '/data-compute'})

if(this.params.createId && this.params.createId !== bus.userInfo.user.id){
this.$http.get("api/wtcp-recommend/public/travelPlan/app/reference?id=" + this.params.travelId[0].nowId + "&userId=" + bus.userInfo.user.id + '&deptCode=' + this.DEPT_CODE.DEPTCODE).then((response) => {

})
}
}
}
}
};
